export const DATE_TYPE = {
  year: 'year',
  month: 'month',
  date: 'date'
};
